import React, { useEffect, useState } from 'react';
import { Layout, Typography, Collapse, Card, Empty } from 'antd';
import './apiDocsViewer.css';
import MethodBadge from './MethodBadge/MethodBadge';
import EndPointSection from './EndPointSection/EndPointSection';
import DiscriptionSection from './DiscriptionSection/DiscriptionSection';
import { useDispatch, useSelector } from 'react-redux';
import { updateOpenApiSpec } from '../../features/organization/organizationSlice';
import { useParams } from 'react-router-dom';
import { FileOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Text } = Typography;
const { Panel } = Collapse;

const ApiDocsViewer = (props) => {
  const { spec } = props;
  const params = useParams();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateOpenApiSpec({ spec, id: params?.pageId ?? params?.folderId }));
  }, [spec]);

  if (!spec) {
    return (
      <Empty
        style={{ marginTop: '40px' }}
        image={<FileOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />}
        description={
          <Text type="secondary">This collection is currently empty. Documents may be added by authorized users.</Text>
        }
      />
    );
  }

  const [responseCode, setResponseCode] = useState('200');

  const organization = useSelector((state) => state.organization);
  const { selectedOpenApiPath: selectedPath, openApimethod: selectedMethod } = organization;

  return (
    <Layout className="api-docs-viewer">
      <Content className="content">
        {selectedPath && selectedMethod && spec?.paths?.[selectedPath]?.[selectedMethod] ? (
          <EndPointSection
            servers={spec?.servers}
            path={selectedPath}
            method={selectedMethod}
            operation={spec?.paths?.[selectedPath]?.[selectedMethod]}
            responseCode={responseCode}
            setResponseCode={setResponseCode}
            spec={spec}
          />
        ) : (
          <div className="endpoint-content" style={{ display: 'block' }}>
            <h1 className="file-heading">{spec?.info?.title}</h1>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <MethodBadge method={spec?.info?.version} />
            </div>
            {spec?.info?.description && <DiscriptionSection input={spec.info.description} />}
            <Card title="API Base Url">
              {spec?.servers && spec?.servers?.length > 0 ? (
                <Collapse>
                  {spec?.servers?.map((server) => (
                    <Panel header={server?.description ?? 'Server Url'} key={server?.description}>
                      <pre className="response-headers">
                        <Text className="endpoint-path">{server?.url}</Text>
                      </pre>
                    </Panel>
                  ))}
                </Collapse>
              ) : (
                'Base Url not mentioned'
              )}
            </Card>
          </div>
        )}
      </Content>
    </Layout>
  );
};

export default ApiDocsViewer;
